const options = {
  masaAktifPaket: {
    title: "Tipe Masa Aktif",
    options: [
      {
        value: 1,
        title: "Akumulasi",
        information: "Masa aktif akan bertambah (terakumulasi) setiap pembelian paket.",
      },
      {
        value: 2,
        title: "Terlama",
        information:
          "Masa aktif akan dipilih yang terlama antara sisa masa aktif dan jumlah masa aktif paket yang dibeli.",
      },
      {
        value: 3,
        title: "Terbaru",
        information: "Masa aktif paket yang dibeli akan menggantikan sisa masa aktif yang ada.",
      },
    ],
  },
  jikaKedaluarsa: {
    title: "Jika Kedaluarsa",
    options: [
      {
        value: 1,
        title: "Hangus",
        information: "Sisa kuota paket akan hangus dan tidak bisa digunakan kembali, jika masa aktif habis.",
      },
      {
        value: 2,
        title: "Roll-Up",
        information:
          "Sisa kuota paket akan tersimpan, meskipun masa aktif habis & akan terakumulasi saat membeli lagi paket yang sama.",
      },
    ],
  },
};
export default options;
